module.exports = __webpack_public_path__ + "img/command02.c29efefa.png";